<template>
  <div :class="classes" @click="clickHandler">
    <rt-icon
      v-if="prefixIcon"
      :name="prefixIcon"
      class="rt-detail-button-prefix-icon"
    ></rt-icon>
    <slot />
    <rt-icon
      v-if="suffixIcon"
      :name="suffixIcon"
      class="rt-detail-button-suffix-icon"
    ></rt-icon>
  </div>
</template>
<script>
export default {
  name: 'RtDetailButton',
  props: {
    prefixIcon: String,
    suffixIcon: String,
    disabled: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    classes() {
      return [
        'rt-detail-button',
        {
          'is-disabled': this.disabled
        }
      ];
    }
  },
  methods: {
    clickHandler(event) {
      this.$emit('click', event);
    }
  }
};
</script>



// WEBPACK FOOTER //
// rtDetailButton.vue?34d3d9c8